export function mapEdgesToNodes(data) {
    if (!data.edges) return [];
    return data.edges.map((edge) => edge.node);
}

export const isMobile = () => (window.innerWidth < 900 ? true : false);

export function toCamelCase(str) {
    return str.replace(/-([a-z])/g, function (m, s) {
        return s.toUpperCase();
    });
}

export function toAttachedString(str){
    return str.split(' ').join('-')
}
